/* eslint-disable no-nested-ternary */
import React from "react";
import { FormattedMessage } from "react-intl";

import CountDown from "@components/countdown/countdown";
import RemoveAdsLink from "@components/remove-ads-link/remove-ads-link";

import { formatUrlWithLocale } from "@helpers/format-url-with-locale";
import { IUser } from "@typings/global.types";

import { useGetExerciseEntrypointQuery } from "../../api/exercise-entrypoint";

import { BlackFridayDecoration } from "./black-friday-decoration";

function contentRemoveAds() {
  //   eslint-disable-next-line react-hooks/rules-of-hooks
  const { data } = useGetExerciseEntrypointQuery({
    exerciseId: 0,
  });

  const onClickHandler = () => {
    document.cookie = `eventCategory=RemoveAds_popUp; path=/;`;
    window.sessionStorage.setItem("modalClosed", "true");
  };

  return (
    <>
      <div className='modal-header p-4 pb-0 md:p-6 md:pb-0'>
        <div className='relative px-8 text-center'>
          {data?.user.isPromotion ? (
            <BlackFridayDecoration />
          ) : window.reactApp.isBirthDay ? (
            <img
              src='/static/img/birthday/2025/bdayLarge.svg'
              alt='birthday'
              className='mx-auto mb-3 md:mb-4'
            />
          ) : data?.user.isSale ? (
            <div className='mb-4'>
              <CountDown userRegDateTime={data?.user.regDatetime} />
            </div>
          ) : (
            <img
              src='/static/img/sunglasses-dark.svg'
              width='100'
              height='100'
              alt=''
              className='mx-auto mb-3 md:mb-4'
            />
          )}
          <h3>
            {data?.user.isPromotion ? (
              <FormattedMessage id='black-week-discount' />
            ) : window.reactApp.isBirthDay ? (
              <FormattedMessage id='birthday-discount-modal-title' />
            ) : data?.user.isSale ? (
              <FormattedMessage id='modal-remove-discounted-ads-title' />
            ) : (
              <FormattedMessage id='remove-ads-modal-title' />
            )}
          </h3>
        </div>
      </div>
      <hr className='mx-4 mt-1 border-t-2 border-transparent transition-all md:mx-6' />
      <div className='modal-body p-4 pt-0 md:p-6 md:pt-0'>
        <div className='text-center'>
          <p>
            {data?.user.isPromotion ? (
              <FormattedMessage id='remove-ads-and-get-benefits' />
            ) : window.reactApp.isBirthDay ? (
              <FormattedMessage id='remove-ads-and-get-benefits' />
            ) : data?.user.isSale ? (
              <FormattedMessage id='modal-remove-discounted-ads-text' />
            ) : (
              <FormattedMessage id='remove-ads-setting-modal' />
            )}
          </p>
          {data?.user.isPromotion ? (
            <a
              className='btn btn-primary text-txt-primary'
              href={formatUrlWithLocale("/ratatype-plus/")}
              onClick={onClickHandler}
              id='RemoveAds_popUp'
            >
              <FormattedMessage id='get-discount' />
            </a>
          ) : window.reactApp.isBirthDay ? (
            <RemoveAdsLink id='RemoveAds_popUp' translationID='get-discount' />
          ) : (
            <RemoveAdsLink
              id='RemoveAds_popUp'
              translationID={
                window.reactApp.isTrialShow
                  ? "modal-try-trial-btn"
                  : "activate-plus"
              }
            />
          )}
        </div>
      </div>
    </>
  );
}

export default contentRemoveAds;
